import { useState } from "react";
import { Link } from "react-router-dom";
import { Twitter, Facebook, Instagram, Youtube, Rss } from "lucide-react";
import { CATEGORIES, CATEGORY_LABELS } from "@/lib/format";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Angemeldet."); setEmail("");
    } catch { toast.error("Anmeldung fehlgeschlagen."); }
  };
  return (
    <footer data-testid="site-footer" className="bg-prussian text-white mt-16 border-t border-gold/60">
      <div className="max-w-[1240px] mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="font-headline font-bold text-2xl tracking-[0.08em]">KONTINENTZEIT</Link>
          <p className="mt-3 text-sm text-white/60 leading-relaxed font-body">
            Unabhängiger Journalismus über Deutschland und Europa. Sachlich, gründlich, verlässlich.
          </p>
          <div className="flex gap-4 mt-5 text-white/70">
            <a href="#" aria-label="Twitter" className="hover:text-gold"><Twitter size={18} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-gold"><Facebook size={18} /></a>
            <a href="#" aria-label="Instagram" className="hover:text-gold"><Instagram size={18} /></a>
            <a href="#" aria-label="Youtube" className="hover:text-gold"><Youtube size={18} /></a>
            <a href="#" aria-label="RSS" className="hover:text-gold"><Rss size={18} /></a>
          </div>
        </div>

        <div>
          <h3 className="font-body font-bold uppercase text-xs tracking-wider text-gold mb-4">Rubriken</h3>
          <ul className="space-y-2.5 text-sm font-body text-white/80">
            {CATEGORIES.map((c) => (
              <li key={c}><Link to={`/rubrik/${c}`} className="hover:text-gold transition-colors">{CATEGORY_LABELS[c]}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-body font-bold uppercase text-xs tracking-wider text-gold mb-4">Verlag</h3>
          <ul className="space-y-2.5 text-sm font-body text-white/80">
            <li><Link to="/impressum" className="hover:text-gold">Impressum</Link></li>
            <li><Link to="/kontakt" className="hover:text-gold">Kontakt</Link></li>
            <li><Link to="/datenschutz" className="hover:text-gold">Datenschutz</Link></li>
            <li><Link to="/archiv" className="hover:text-gold">Archiv</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-body font-bold uppercase text-xs tracking-wider text-gold mb-4">Newsletter</h3>
          <p className="text-sm text-white/60 mb-3 font-body">Jeden Morgen die wichtigsten Meldungen.</p>
          <form onSubmit={submit} className="flex flex-col gap-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="footer-newsletter-input" placeholder="E-Mail-Adresse"
              className="bg-white/95 text-charcoal px-3 py-2.5 text-sm outline-none" />
            <button data-testid="footer-newsletter-submit" className="border border-white/50 text-white font-semibold text-xs uppercase tracking-wide py-2.5 hover:bg-white hover:text-prussian transition-colors">
              Abonnieren
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1240px] mx-auto px-4 py-4 text-xs text-white/50 font-body flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} KONTINENTZEIT Medien GmbH. Alle Rechte vorbehalten.</span>
          <span>Berlin · Frankfurt</span>
        </div>
      </div>
    </footer>
  );
}
